'use client';

import type { ChangeEvent } from 'react';
import type { SelectOption } from '@/app/components/forms/select';
import { Select } from '@/app/components/forms/select';
import { safeCall } from '@/app/utils/safeCall';
export type MaintenanceListSelectType = {
  name: string;
  placeholder: string;
  options: SelectOption[];
  label?: string;
  required?: boolean;
};
export interface MaintenanceListSelectsProps {
  selectOptionValues: string[];
  options: MaintenanceListSelectType[];
  className?: string;
  disabled?: boolean;
  onSelectOption: (updateIndex: number, updateValue: string) => void;
}
export const MaintenanceListSelects = ({
  selectOptionValues = [],
  options = [],
  className,
  disabled = false,
  onSelectOption
}: MaintenanceListSelectsProps) => {
  const handleOnChange = (e: ChangeEvent<HTMLSelectElement>, index: number) => {
    if (!e?.target) return;
    safeCall(onSelectOption, index, e?.target?.value);
  };
  return options.map((item, index) => <Select key={`${item.name}${index}`} name={item.name} label={item.label} required={item.required ?? false} options={item.options} placeholder={item.placeholder} value={selectOptionValues[index]} disabled={index > 0 && !selectOptionValues[index - 1] || disabled} className={className} onChange={e => handleOnChange(e, index)} />);
};